module.exports = __webpack_public_path__ + "static/media/flappy-pappy.1f75902d.png";